import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';

import Config from '@skin_config';
import BetBuilder from '@external/betBuilder';
import { PreferencesContext } from '@common/contexts/preferences';
import BetBuliderBetslip from './components/betslip';
import IdleService from '@common/services/idle';
import { useDispatch } from 'react-redux';
import { HandleMousePosition } from '@app/dev/actions/terminal';

import './style.scss'; 

const BetBuilderWrapper = ({ sportcastId, title, closePopup }) => {
  const [{ lang, oddsFormat }] = useContext(PreferencesContext);
  const [betData, setBetData] = useState(null);
  const dispatch = useDispatch();

  const onUpdate = (command, data) => {
    const commandMap = {
      addToBetslip: () => setBetData(data),
    };

    commandMap[command]?.();
  };

  const resetInactiveTimer = () => {
    IdleService.resetTimer();
    dispatch(HandleMousePosition({ x: 0, y: 0 }));
  }

  return <div className="bet-builder-wrapper">
    <div className="bet-builder-content-wrapper">
      <BetBuilder
        title={title}
        sportcastId={sportcastId}
        language={lang}
        closePopup={closePopup}
        oddsFormat={oddsFormat}
        skinConfig={{
          ...Config.betBuilder,
          unfocusForInactivity: Config.main.unfocusForInactivity
        }}
        isBetslipVisible={!!betData}
        updateHandler={onUpdate}
        resetInactiveTimer={resetInactiveTimer}
      />
      {betData && <div className="bet-builder-betslip-wrapper">
        <BetBuliderBetslip betData={betData} onClear={() => setBetData(null)} />
      </div>}
    </div>
  </div>;
};

BetBuilderWrapper.propTypes = {
  sportcastId: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  closePopup: PropTypes.func,
};

export default BetBuilderWrapper;
